var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"section is-main-section"},[_c('CardComponent',[_c('div',{staticClass:"section has-text-centered"},[_c('h1',{staticClass:"title"},[_vm._v("Page Not Found")])])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }